import { Component, EventEmitter, Query, ViewChild, Output, Input, ViewChildren, ContentChildren, Directive, ElementRef, QueryList, OnInit, trigger, state, animate, style, transition, keyframes, group } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, paymenticon, accountpayment, terms, paypalpayment, giftwindow, giftpayment, giftcontainer, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewSwitch, viewOptionList, viewDetails, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewInfoItem, viewInfoText, taglineSpan, taglineField, viewItems, gamecopies, newsWindow }  from '../animations.overlay';
import { featuresBox, featureslist }  from '../animations.panels';
import { Http, Response, Headers } from '@angular/http';

import { AppComponent } from '../../app.component';
import { UserService } from '../../services/user.service';
import { StoreService } from '../../services/store.service';
import { environment } from '../../environment';

// Products
import { Item } from '../../models/item';
import { Product } from '../../models/product';
import { News } from '../../models/news';
import { Filter } from '../../models/filter.constructor';

declare var $: any

@Component({
  selector: 'user-features',
  templateUrl: './user.features.html',
  providers: [ UserService ],
  animations: [ featuresBox, featureslist, featuresBox, overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, paymenticon, accountpayment, terms, paypalpayment, giftwindow, giftpayment, giftcontainer, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewOptionList, viewDetails, viewSwitch, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewInfoItem, viewInfoText, taglineSpan, taglineField, viewItems, gamecopies, newsWindow ]
})
export class FeaturesComponent implements OnInit {

	/* Header Tokens */

	public token: any;

	showNews = true;
	showFeatures = true;
	loading = true;

	/* Models */
	itemquery = new Filter();
	products: Product;
	features: Item;
	news: News;
	x = 0;
	y = 0;

	// Settings for 'Show More...' links
	expandedChars = 100000;
	condensedChars = 800;
	limit = [this.condensedChars, this.condensedChars];

	constructor(private http : Http,
				private user: UserService,
  			  	private store: StoreService,
				private sanitizer: DomSanitizer) { 

	}
	
	/* Get News */
	getNews(): Promise<News> {
		return this.http
			.get(`${environment.baseUrl}/updates/`)
			.toPromise()
			.then(mapNews)
			.catch((err) => {
				// toss
			})
  	}

	/* On with the show */
	ngOnInit() {

		Promise.resolve(this.store.getItems()).then( (items) =>  {
			
			this.features = items
		});

		Promise.resolve(this.getNews()).then( (newsItems) => {
			if (newsItems[0]) this.loading = false;
			this.news = newsItems
		});

	}

	nextItem() {
		if ( this.y < 1 ) this.y = this.y+1
	}

	prevItem() {
		if ( this.y > 0 ) this.y = this.y-1
	}

	ngOnChanges(reloadClaims) {

    }
}


function mapNews(response?:Response): News {
	let res = response.json().map(toNewsFeed);
	return res;
}

function toNewsFeed(r?:any): News {
	let newsItems = <News>({
		tid: r.tid,
		title: r.title,
		title_seo: r.title_seo,
		start_date: r.start_date,
		starter_id: r.starter_id,
		starter_name: r.starter_name,
		topic_firstpost: r.topic_firstpost,
		post: r.post,
		url: r.url,
		author_url: r.author_url,
		comments_url: r.comments_url
	});
	return newsItems;
}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/user-features/user.features.component.ts